


import {Component, Vue} from "vue-property-decorator";
import AccountSetting from "@/views/admin/setting/components/accountSetting.vue";
import CycleSetting from "@/views/admin/setting/components/cycleSetting.vue";
import ReceiversSetting from "@/views/admin/setting/components/receiversSetting.vue";
import WechatFeePercentSetting from "@/views/admin/setting/components/wechatFeePercentSetting.vue";
import FeeDisplayNamesSetting from "@/views/admin/setting/components/feeDisplayNamesSetting.vue";

@Component({
  name: 'SplitOrderSetting',
  components: {FeeDisplayNamesSetting, ReceiversSetting, CycleSetting, AccountSetting, WechatFeePercentSetting}
})
export default class splitOrderSetting extends Vue {

}

